import React from 'react';
import {Grid} from 'semantic-ui-react';
import {Step, Stepper, StepButton} from 'material-ui/Stepper';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import WelcomePage from './welcome-page';
import TemplateSettingsPage from './template-settings-page';

export class TemplateBoardingPage extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			stepIndex: 0
		};
	}

	handleNext = () => {
		const {stepIndex} = this.state;
		if (stepIndex < 2) {
			this.setState({stepIndex: stepIndex + 1});
		}
	};

	handlePrev = () => {
		const {stepIndex} = this.state;
		if (stepIndex > 0) {
			this.setState({stepIndex: stepIndex - 1});
		}
	};

	getStepContent = (stepIndex) => {
		switch (stepIndex) {
			case 0:
				return <WelcomePage />;
			case 1:
				return <TemplateSettingsPage />;
			case 2:
				return 'This is the bit I really care about!';
			default:
				return 'You\'re a long way from home sonny jim!';
		}
	}

	render () {
		const {stepIndex} = this.state;

		return (
			<Grid centered stackable className="with-padding">
				<Grid.Row>
					<Grid.Column>
						<Stepper linear={false} activeStep={stepIndex}>
							<Step>
								<StepButton onClick={() => this.setState({stepIndex: 0})}>
									Welcome to Chated.io
								</StepButton>
							</Step>
							<Step>
								<StepButton onClick={() => this.setState({stepIndex: 1})}>
									Customize your email
								</StepButton>
							</Step>
							<Step>
								<StepButton onClick={() => this.setState({stepIndex: 2})}>
									Enable this feature
								</StepButton>
							</Step>
						</Stepper>
					</Grid.Column>
				</Grid.Row>
				<Grid.Row>
					<Grid.Column>
						<p>{this.getStepContent(stepIndex)}</p>
					</Grid.Column>
				</Grid.Row>
				<Grid.Row>
					<Grid.Column>
						<FlatButton
							label="Back"
							disabled={stepIndex === 0}
							onClick={this.handlePrev}
							style={{marginRight: 12}}
						/>
						<RaisedButton
							label="Next"
							disabled={stepIndex === 2}
							primary={true}
							onClick={this.handleNext}
						/>
					</Grid.Column>
				</Grid.Row>
			</Grid>
		);
	}
}

export default TemplateBoardingPage;



// WEBPACK FOOTER //
// ./src/containers/template-boarding-page/index.js